module.exports = __webpack_public_path__ + "media/images/spree/frontend/logo/logo-9f17c3fdbe2161281e6f4ce64f6e4209.png";